import { Spinner } from 'components/ui';
import { getPublicToken } from 'modules/auth/selectors';
import React from 'react';

import { useSelector } from 'hooks';
import { createSearchParams, useNavigate } from 'react-router';
import { buildStepUrl } from 'utils/stepUrlUtils';
import { getUrlParam } from 'utils/urlUtils';
import { CONFIRMATION_BASE_URL } from 'constants/url';

const Redirect: React.FC = () =>{
  const navigate = useNavigate();
  const publicToken = useSelector(getPublicToken);
  const token = getUrlParam('redirectToken');

  const type = getUrlParam('type');
  const step = getUrlParam('step');
  const origin = getUrlParam('origin');
  const canRedirect = token === publicToken && type && step;

  React.useEffect(() => {
    if (canRedirect) {
      const redirectUrl = buildStepUrl(`/${type}`, step, createSearchParams({ token }));
      navigate(redirectUrl);

    } else {
      navigate({
        pathname: CONFIRMATION_BASE_URL,
        search: createSearchParams({ origin }).toString(),
      });
    }
  // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, []);

  return <Spinner />;
};

export default Redirect;